import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        accessToken: null,
        loggingIn: false,
        loginError: null
    },
    mutations: {
        loginStart: state => state.loggingIn = true,
        loginStop: (state, errorMessage) => {
            state.loggingIn = false;
            state.loginError = errorMessage;
        },
        updateAccessToken: (state, accessToken) => {
            state.accessToken = accessToken;
        }
    },
    actions: {
        doLogin({ commit }, logInfo) {
            commit('loginStart');

            axios.get('/silver/login', {params:{ id: logInfo.id, pass : logInfo.pass }}
            )
                .then(response => {

                    localStorage.setItem('accessToken', response.data.token);
                    commit('loginStop', null);
                    commit('updateAccessToken', response.data.token);
                })
                .catch(error => {
                    commit('loginStop', "로그인에 실패했습니다.");
                    commit('updateAccessToken', null);
                })
        },
        doLogout({ commit }, logInfo) {
            commit('loginStart');
            axios.get('/silver/logout'
            )
                .then(response => {
                    localStorage.setItem('accessToken', response.data.token);
                    commit('updateAccessToken', null);

                })
                .catch(error => {
                    commit('loginStop', "로그인에 실패했습니다.");
                    commit('updateAccessToken', null);
                })
        },
        fetchAccessToken({ commit }) {
            commit('updateAccessToken', localStorage.getItem('accessToken'));
        }
    }
})